<template>
  <b-card
      title="مدیریت دسته بندی های توصیه"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <b-row>
          <div class="filter-row">
            <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="showModal = true"
            >
              جدید
            </b-button>
          <b-col md="2">
            <b-form-group
                label="عنوان"
                label-for="Title"
            >
              <b-form-input
                  v-model="filterOptions.Title"
                  @keyup.enter="update(1)"
              />
            </b-form-group>
          </b-col>
            <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
            >فیلتر
            </b-button>
          </div>
        </b-row>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                class="font-weight-bold"
                @click="showEditModal(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="EditIcon"
                  size="16"
                  @click="showEditModal(data.item)"
              />
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <b-modal
        v-model="showModal"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="جزئیات دسته بندی توصیه"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
        @cancel="closeModal()"
        @hide="closeModal()"
    >
      <b-row>
        <b-col>
          <b-form-group
              label="عنوان"
              label-for="Title"
          >
            <b-form-input
                id="Title"
                v-model="form.Title"
                name="Title"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>

</template>

<script>
export default {
  name: 'ListCalorie',
  data() {
    return {
      loading: false,
      editCalorie: false,
      filterOptions: {
        Page: 1,
        Title: '',
        PerPage: 10,
      },
      form: {
        Title: null,
      },
      totalRows: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      showModal: false,
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      this.$http.post(this.$api.recommendcategory.getlist, this.filterOptions).then(res => {
        this.items = res.data
        this.totalRows = res.totalRow
      }).finally(() => {
        this.loading = false
      })
    },
    showEditModal(item) {
      this.showModal = true
      this.editCalorie = true
      this.form = { ...item }
    },
    save() {
      let url
      if (this.editCalorie) url = this.$api.recommendcategory.update
      else url = this.$api.recommendcategory.add
      this.$http.post(url, this.form).then(() => this.update())
    },
    remove(id) {
      this.removeRow(this.$api.recommendcategory.remove, 'Id', id)
    },
    closeModal() {
      this.showModal = false
      this.editCalorie = false
      Object.keys(this.form).forEach(key => { this.form[key] = null })
    },
  },
}
</script>

<style scoped>

</style>
